import { HttpClient } from '@/data/protocols'
import { AxiosHttpClient } from '@/infra/http'
import { makeLocalStorageAdapter } from '@/main/factories/cache'

export const makeAxiosHttpClient = <T>(): HttpClient<T> => {
  return new AxiosHttpClient<T>(makeLocalStorageAdapter())
}
